import { ORDENES_DEVOLUCION } from '../actions/types';

const marker = String.fromCharCode(92,117,48,51,48,48,45,92,117,48,51,54,102);
const normalizeRegex = new RegExp('[' + marker + ']', 'g');

const normalize = (val) => {
    if (val === null || val === undefined) return '';
    return (val + '')
        .toLowerCase()
        .normalize('NFD')
        .replace(normalizeRegex, '')
        .trim();
};

const initialState = {
    listado: [],
    filtrado: [],
    error: null,

    detalle: null,
    loadingDetalle: false,

    inventarioEntregado: [],
    paquetesEntregado: [],
    loadingInventarioEntregado: false
};

export default function ordenesDevolucionReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case ORDENES_DEVOLUCION.LISTAR: {
            const listado = Array.isArray(payload) ? payload : [];
            return {
                ...state,
                listado,
                filtrado: listado,
                error: null
            };
        }

        case ORDENES_DEVOLUCION.FILTRAR: {
            const texto = normalize(payload);
            if (!texto) {
                return { ...state, filtrado: state.listado };
            }

            const filtrado = state.listado.filter((o) => {
                const folio = normalize(o?.folio);
                const observaciones = normalize(o?.observaciones);

                return folio.includes(texto) || observaciones.includes(texto);
            });

            return { ...state, filtrado };
        }

        case ORDENES_DEVOLUCION.LIMPIAR:
            return { ...initialState };

        case ORDENES_DEVOLUCION.DETALLE_CARGANDO:
            return {
                ...state,
                detalle: null,
                loadingDetalle: true
            };

        case ORDENES_DEVOLUCION.DETALLE:
            return {
                ...state,
                detalle: payload || null,
                loadingDetalle: false
            };

        case ORDENES_DEVOLUCION.LIMPIAR_DETALLE:
            return {
                ...state,
                detalle: null,
                loadingDetalle: false
            };

        case ORDENES_DEVOLUCION.INVENTARIO_ENTREGADO_CARGANDO:
            return {
                ...state,
                inventarioEntregado: [],
                paquetesEntregado: [],
                loadingInventarioEntregado: true
            };

        case ORDENES_DEVOLUCION.INVENTARIO_ENTREGADO:
            return {
                ...state,
                inventarioEntregado: Array.isArray(payload?.productos) ? payload.productos : [],
                paquetesEntregado: Array.isArray(payload?.paquetes) ? payload.paquetes : [],
                loadingInventarioEntregado: false
            };

        case ORDENES_DEVOLUCION.LIMPIAR_INVENTARIO_ENTREGADO:
            return {
                ...state,
                inventarioEntregado: [],
                paquetesEntregado: [],
                loadingInventarioEntregado: false
            };

        case ORDENES_DEVOLUCION.ERROR:
            return { ...state, error: payload, loadingDetalle: false, loadingInventarioEntregado: false };

        default:
            return state;
    }
}
